export const websiteEnv = {
  isUnitedStates: process.env.NEXT_PUBLIC_STORE_VIEW_CODE === 'us',
  isUnitedKingdom: process.env.NEXT_PUBLIC_STORE_VIEW_CODE === 'uk',
  isCanada: process.env.NEXT_PUBLIC_STORE_VIEW_CODE === 'ca',
  isAustralia: process.env.NEXT_PUBLIC_STORE_VIEW_CODE === 'au',
  isIreland: process.env.NEXT_PUBLIC_STORE_VIEW_CODE === 'ie',
  isNewZealand: process.env.NEXT_PUBLIC_STORE_VIEW_CODE === 'nz',
  isGermanyEnglish: process.env.NEXT_PUBLIC_STORE_VIEW_CODE === 'de_en',
};
